import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Editor } from 'primereact/editor';
import { Toast } from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL } from '../../../shared/utility';
import { Companyid,DROPDOWN_CONFIG } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';



// ---- SOP editor helpers (same as AddPosition) ----
// SOP values are stored as HTML (from the rich text editor). Older records hold plain text.
const looksLikeHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(value || '');

const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

// Plain text (old records) -> HTML paragraphs so line breaks survive in the editor
const toEditorHtml = (value) => {
    if (!value) { return ''; }
    if (looksLikeHtml(value)) { return value; }
    return String(value).split(/\r?\n/).map(line => '<p>' + (escapeHtml(line) || '<br>') + '</p>').join('');
};

const emptyForm = {
    JobPurpose: '',
    SuggestedKpis: '',
    DepartmentId: null,
    PositionId: null
};

class AddRolesResponsibilities extends Component {
    rowUidCounter = 0;

    // One responsibility row = one record (roleResponsibilityId is set only for rows loaded from the API)
    createRow = () => {
        this.rowUidCounter += 1;
        return { uid: 'row_' + this.rowUidCounter, RoleResponsibilityId: null, KeyResponsibilities: '', SopTamil: '', SopEnglish: '', expanded: false };
    }

    state = {
        type: 'add',
        ...emptyForm,
        Responsibilities: [this.createRow()],
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        this.setState({ type });

        this.props.getMasterKeywordList('Job');
        this.props.getMasterKeywordList('Department');
        this.props.getMasterKeywordList('resRolesandResponsibility');
        this.props.fetchPositionLists();

        if (type !== 'add') {
            this.props.getMasterTableList(
                `res/GetResRolesResponsibilitiesbyid?RoleResponsibilityId=${id}`,
                this.state.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.type === 'add' || this.props.tableLists === prevProps.tableLists) { return; }

        const record = Array.isArray(this.props.tableLists) ? this.props.tableLists[0] : this.props.tableLists;
        if (!record) { return; }

        // Null / missing values never break the form: text falls back to '', ids to null
        this.setState({
            JobPurpose: record.jobPurpose ?? '',
            SuggestedKpis: record.suggestedKpis ?? '',
            DepartmentId: record.departmentid ?? record.departmentId ?? null,
            PositionId: record.positionId ?? record.positionid ?? null,
            Responsibilities: [{
                ...this.createRow(),
                RoleResponsibilityId: record.roleResponsibilityId ?? this.props.match.params.id ?? null,
                KeyResponsibilities: record.keyResponsibilities ?? '',
                SopTamil: record.soptamil ?? '',
                SopEnglish: record.sopenglish ?? ''
            }],
            touch: false
        });
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // Same row operations as AddPosition's responsibilities: add, remove, update, expand/collapse
    addResponsibility = (e) => {
        e.preventDefault();
        this.setState({ Responsibilities: [...this.state.Responsibilities, this.createRow()], touch: true });
    }

    removeResponsibility = (e, index) => {
        e.preventDefault();
        this.setState({ Responsibilities: this.state.Responsibilities.filter((r, i) => i !== index), touch: true });
    }

    updateResponsibility = (index, patch, markTouched = true) => {
        let rows = [...this.state.Responsibilities];
        rows[index] = { ...rows[index], ...patch };
        this.setState(markTouched ? { Responsibilities: rows, touch: true } : { Responsibilities: rows });
    }

    toggleResponsibility = (e, index) => {
        e.preventDefault();
        this.updateResponsibility(index, { expanded: !this.state.Responsibilities[index].expanded }, false);
    }

    // Adapts the Editor's onTextChange to the row. Programmatic changes and unchanged content
    // (the editor echoing a loaded value) are ignored so opening a record doesn't mark it as changed.
    changeEditor = (field, index) => (e) => {
        if (typeof e.source === 'string' && e.source !== 'user') { return; }
        let row = this.state.Responsibilities[index];
        if (!row) { return; }
        let value = e.htmlValue || '';
        if (value === toEditorHtml(row[field])) { return; }
        this.updateResponsibility(index, { [field]: value });
    }

    responsibilityCellTemplate = (rowData, column) => {
        let index = column.rowIndex;
        let expanded = rowData.expanded === true;
        let isView = this.state.type === 'view';

        // Saved value stays selectable even if it is not in the master list
        let options = (this.props.Responsibilities || []).map(r => ({ label: r.label, value: r.label }));
        if (rowData.KeyResponsibilities && !options.some(o => o.value === rowData.KeyResponsibilities)) {
            options = [{ label: rowData.KeyResponsibilities, value: rowData.KeyResponsibilities }, ...options];
        }

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button type="button" icon={expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'} className="p-button-secondary" style={{ marginRight: '0.5em' }} title={expanded ? 'Collapse' : 'Expand'} onClick={(e) => this.toggleResponsibility(e, index)} />
                    <Dropdown key={rowData.uid} className="p-col-12" style={{ flex: 1 }} value={rowData.KeyResponsibilities} options={options} onChange={(e) => this.updateResponsibility(index, { KeyResponsibilities: e.value })} name="KeyResponsibilities" placeholder="Select Responsibility"
                        disabled={isView} {...DROPDOWN_CONFIG} />
                </div>
                {expanded && (
                    <div style={{ marginTop: '0.5em' }}>
                        <label className="label">SOP Tamil</label>
                        <div className="mt1">
                            <Editor key={rowData.uid + '-sop-tamil'} style={{ height: '320px' }} placeholder="SOP Tamil" readOnly={isView}
                                value={toEditorHtml(rowData.SopTamil)}
                                onTextChange={this.changeEditor('SopTamil', index)} />
                        </div>

                        <label className="label" style={{ display: 'block', marginTop: '1em' }}>SOP English</label>
                        <div className="mt1">
                            <Editor key={rowData.uid + '-sop-english'} style={{ height: '320px' }} placeholder="SOP English" readOnly={isView}
                                value={toEditorHtml(rowData.SopEnglish)}
                                onTextChange={this.changeEditor('SopEnglish', index)} />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    // A row loaded from the API can't be deleted here (that would not delete the saved record)
    responsibilityActionTemplate = (rowData, column) => {
        return (
            <Button icon="pi pi-trash" className="p-button-danger" disabled={this.state.Responsibilities.length <= 1 || this.state.type === 'view' || !!rowData.RoleResponsibilityId} onClick={(e) => this.removeResponsibility(e, column.rowIndex)} />
        );
    }

    add = () => {
        // Each responsibility row is saved as its own record using the flat payload; the shared
        // fields repeat on every row. roleResponsibilityId only exists for rows being updated
        // (rows added during an edit are inserted); null values are sent as "".
        this.state.Responsibilities.forEach(row => {
            let isUpdate = (this.state.type === 'edit' && !!row.RoleResponsibilityId);
            var data = {
                ...(isUpdate && { roleResponsibilityId: row.RoleResponsibilityId }),
                jobPurpose: this.state.JobPurpose ?? '',
                keyResponsibilities: row.KeyResponsibilities ?? '',
                suggestedKpis: this.state.SuggestedKpis ?? '',
                reportsTo: '',
                departmentid: this.state.DepartmentId ?? '',
                positionId: this.state.PositionId ?? '',
                soptamil: row.SopTamil ?? '',
                sopenglish: row.SopEnglish ?? ''
            };

            this.props.processDynamicData('invrolesandresponsibilities', isUpdate ? 'edit' : 'add', data, 'res/GetResRolesResponsibilitiesbyid?' + Companyid);
        });
    }

    resetData = () => {
        this.setState({ ...emptyForm, Responsibilities: [this.createRow()], touch: false });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL("/rolesresponsibilities/", this.props);
        }

        let isView = (this.state.type === 'view');
        let isEnabled = (this.state.touch === true);
        let accessButton = { addAccess: true, editAccess: true };

        let positionOptions = this.props.positionList || [];

        // Job Purpose holds the job name (as in the saved payload); keep a saved value selectable even if it is not in the master list
        let jobOptions = (this.props.Jobs || []).map(j => ({ label: j.label, value: j.label }));
        if (this.state.JobPurpose && !jobOptions.some(o => o.value === this.state.JobPurpose)) {
            jobOptions = [{ label: this.state.JobPurpose, value: this.state.JobPurpose }, ...jobOptions];
        }

         let redirectURL = '/rolesresponsibilities/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Roles & Responsibilities</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Job Purpose</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Job" options={jobOptions} value={this.state.JobPurpose} name="JobPurpose" onChange={this.change} disabled={isView} {...DROPDOWN_CONFIG} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Suggested KPIs</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputTextarea rows={4} cols={30} className="width100" name="SuggestedKpis" placeholder="Enter KPI details, performance indicators and targets" value={this.state.SuggestedKpis} onChange={this.change} autoResize={true} disabled={isView} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Department</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Department" options={this.props.Department} value={this.state.DepartmentId} name="DepartmentId" onChange={this.change} disabled={isView} {...DROPDOWN_CONFIG} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Position</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Position" options={positionOptions} value={this.state.PositionId} name="PositionId" onChange={this.change} disabled={isView} {...DROPDOWN_CONFIG} />
                                </div>

                            </div>

                            {/* Responsibility section: SOP Tamil / SOP English live inside the responsibility row, as in AddPosition */}
                            <div className="p-col-12">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <label htmlFor="acSimple">Responsibility</label>
                                    </div>
                                    <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button label="Add Responsibility" icon="pi pi-plus" onClick={this.addResponsibility} disabled={isView} />
                                    </div>
                                    <div className="p-col-12">
                                        <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                            dataKey="uid" rows={10} value={this.state.Responsibilities} style={{ width: '100%' }}>
                                            <Column header="Responsibility" body={this.responsibilityCellTemplate} />
                                            <Column header="Action" body={this.responsibilityActionTemplate} style={{ textAlign: 'center', width: '8em' }} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || isView}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/rolesresponsibilities/"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        positionList: state.master.positionList,
        Jobs: (state.keyword.Job !== undefined) ? state.keyword.Job : [],
        Department: (state.keyword.Department !== undefined) ? state.keyword.Department : [],
        Responsibilities: (state.keyword.resRolesandResponsibility !== undefined) ? state.keyword.resRolesandResponsibility : []
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchPositionLists: () => dispatch(actions.fetchPositionLists()),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddRolesResponsibilities);
